import config from '~/config';

export default function parseUrlPriceType(
	priceType: string | (string | null)[] | null = config.product.defaultPriceType
): string | null {
	if (priceType === 'first-available' || Array.isArray(priceType) || !priceType) {
		return null;
	}

	if (config.product.priceTypes.find((type) => type.code === priceType) !== undefined) {
		return priceType;
	}

	return config.product.defaultPriceType;
}
